module.exports = __webpack_public_path__ + "static/media/trainingHeroImage.dd8dba3a.png";